import { render, staticRenderFns } from "./MobileCartFooter.vue?vue&type=template&id=440e01fa&"
import script from "./MobileCartFooter.vue?vue&type=script&lang=js&"
export * from "./MobileCartFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports